module.exports = __webpack_public_path__ + "img/map_top.6db549c1.png";